import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import EventEmitter, { SHOW_POPUP_UPGRADE } from '../../../helpers/EventEmitter'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../utils/authorization'
import { Element } from '../../html/element'
import classes from './index.module.scss'

export const AddNewPanel = ({ handleAddNewPanel }) => {
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  const onClick = () => {
    if (
      AUTHORIZATION_API.companyAnalysis.preferenceSettings[
        userType.userTypeId
      ] === AUTHORIZATION_TYPE.ALLOW
    ) {
      handleAddNewPanel()
    } else {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    }
  }

  return (
    <Element
      className={classes.container}
      style={{
        backgroundColor: 'rgba(44, 115, 232, 0.05)',
        borderColor: '#2C73E8',
      }}
      onClick={onClick}
    >
      <Element elementName="span" style={{ color: '#2C73E8' }}>
        <Translate value="common.panel.ADD_NEW_PANEL" />
      </Element>
    </Element>
  )
}

AddNewPanel.propTypes = {
  handleAddNewPanel: PropTypes.func,
}

AddNewPanel.defaultProps = {
  handleAddNewPanel: () => {},
}
